export function Release_1_0() {
    return (
      <div>
        <h2 className="text-sm text-gray-400">Release on: 16 June 2025</h2>
        <h2 className="text-xl font-semibold text-purple-300">Overview</h2>
        <p>
          CashMate 1.0 marks the official launch of our intelligent Point-of-Sale (POS) and business management platform, built specifically for small and medium-sized enterprises 
          (SMEs) in Malaysia. Designed to be intuitive, and compliant with local e-invoicing requirements, this release includes core modules to help businesses 
          streamline daily operations, improve efficiency, and gain insights through real-time reporting, all within a modern, responsive interface.
        </p>
  
        <h2 className="text-xl font-semibold text-purple-300 mt-6">New Features</h2>
        <h3 className="text-lg font-semibold text-white mt-3">Artificial Intelligence</h3>
        <ul className="list-disc list-inside">
            <li>All fetures using AI will be availble on future update including stock predictions, sales predictions and so on.</li>
        </ul>
        <h3 className="text-lg font-semibold text-white mt-3">Cashier</h3>
        <ul className="list-disc list-inside">
            <li>Fully functional POS with support for multiple sales modes: Retail, Dine-in, and Takeaway.</li>
            <li>Real-time cart management with quantity updates, modifiers, and discounts.</li>
            <li>Integrated receipt generator with custom branding, tax calculation, rounding adjustment, and change return logic.</li>
            <li>Receipt numbering resets daily and auto-increments per branch for audit clarity.</li>
            <li>Accepts multiple payment methods: Cash, E-wallet, and Card.</li>
            <li>Void receipt function with reason tracking and status update reflected across system (including public receipt QR).</li>
        </ul>
        <h3 className="text-lg font-semibold text-white mt-3">Sales Report</h3>
        <ul className="list-disc list-inside">
            <li>Generate sales report based on selected date range and product type.</li>
            <li>Export report as PDF.</li>
        </ul>
        <h3 className="text-lg font-semibold text-white mt-3">Table & Queue Order Management</h3>
        <ul className="list-disc list-inside">
            <li>Dine-in Table System: Save and manage orders by table number, with individual item status tracking (e.g., pending, completed).</li>
            <li>Kitchen View: Displays only pending items, auto-updated with every status change.</li>
            <li>Pre-order Queue System: Save incoming orders before payment, assign auto queue numbers, and manage order completion or rejection.</li>
        </ul>
        <h3 className="text-lg font-semibold text-white mt-3">Inventory Management</h3>
        <ul className="list-disc list-inside">
            <li>Product catalog with image uploads and price configuration.</li>
            <li>Real-time inventory deduction upon sale or order saving, including smart logic to avoid double deduction on previously saved orders.</li>
            <li>CRUD operations for products and product types.</li>
            <li>Ingredient-based product configuration (for future AI recipe planning).</li>
        </ul>
        <h3 className="text-lg font-semibold text-white mt-3">Dashboard Overview</h3>
        <ul className="list-disc list-inside">
            <li>Real-time KPIs: total revenue, net profit, unique customers, daily goal tracking.</li>
            <li>Visual chart of monthly sales.</li>
            <li>Daily top 3 selling products and recent transaction list.</li>
        </ul>
        <h3 className="text-lg font-semibold text-white mt-3">Subscription & Billing (via Stripe)</h3>
        <ul className="list-disc list-inside">
            <li>Flexible subscription plans: Free Trial, Starter, Plus, Premium.</li>
            <li>Feature and quota restrictions enforced based on selected plan (e.g., user count, storage, number of cashier tables).</li>
            <li>Billing page with plan switching, invoice history, usage quota, and Stripe integration.</li>
            <li>Promo code support during checkout (WELCOME10, etc.).</li>
            <li>Request cancellation form built-in with manual Stripe sync.</li>
        </ul>
        <h3 className="text-lg font-semibold text-white mt-3">QR Receipt System</h3>
        <ul className="list-disc list-inside">
            <li>After payment, users receive a QR code to access a public version of their receipt.</li>
            <li>Includes business info, full item list, payment status, and printable format.</li>
        </ul>
        <h3 className="text-lg font-semibold text-white mt-3">Business Setup</h3>
        <ul className="list-disc list-inside">
            <li>Onboarding flow prompts new users to create their business and main branch profile.</li>
            <li>Company branding, tax settings, and receipt customization available via Settings.</li>
        </ul>   

        <h2 className="text-xl font-semibold text-purple-300 mt-6">Resolved Issues</h2>
        <ul className="list-disc list-inside">
            <li>Fixed inventory bug that caused incorrect quantity deduction for edited orders.</li>
            <li>Fixed voided receipts not syncing status to public QR view.</li>
            <li>Addressed rounding discrepancies in tax and total calculations.</li>
            <li>Improved receipt rendering on smaller screen widths.</li>
            <li>Fixed issue where dashboard was not loading on initial load.</li>
            <li>Add loading state for necessary components.</li>
            <li>Fixed logout button not working in dashboard.</li>
            <li>Now serving will auto clear order after 10 minutes instead of 1 hour.</li>
        </ul>

        <h2 className="text-xl font-semibold text-purple-300 mt-6">Compatible Devices</h2>
        <ul className="list-disc list-inside">
            <li>Best view on desktop and tablet size.</li>
            <li>Compatible with all devices running on Chrome, Firefox, Safari, and Edge.</li>
        </ul>
      </div>
      
    );
  }
